function extend(core) {
  const Twig = core;
  const applyToken = {
    type: Twig.logic.type.use,
    regex: /^apply+$/,
    next: [],
    open: true,
    compile(token) {
      delete token.match;
      return token;
    },
    parse(token, context, chain) {
      return {
        chain,
        output: '',
      };
    },
  };
  Twig.logic.extend(applyToken);
}

module.exports = extend;



// WEBPACK FOOTER //
// ./src/libs/twig/apply/index.js